import { SimulacionCuota } from "./perfil.model";

export function mapSimulacionCuota(d: any): SimulacionCuota {
    if (!d) {
        throw new Error('Respuesta de simulación inválida');
    }

    return {
        cuotas: d.cuotas,

        tasaEfectivaAnual: Number(d.tasaefectivaanual),
        tasaNominalMensual: Number(d.tasanominalmensual),

        totalCapital: Number(d.totalcapital),
        totalInteres: Number(d.totalinteres),
        totalSeguro: Number(d.totalseguro),
        totalFinanciado: Number(d.totalfinanciado),
        totalFinanciadoConSeguro: Number(d.totalfinanciadoconseguro),

        valorCuota: Number(d.valorcuota),
        tarifaSeguroMillon: Number(d.tarifaseguromillon),

        redondeoDecimales: Number(d.redondeodecimales),

        detalleAmortizacion: (d.detalleamortizacion || []).map((x: any) =>
            mapDetalleAmortizacion(x)
        )
    };
}

function mapDetalleAmortizacion(x: any) {
    return {
        numeroCuota: x.numerocuota,
        capital: Number(x.capital),
        interes: Number(x.interes),
        seguro: Number(x.seguro),
        valorCuota: Number(x.valorcuota),
        saldoCapital: Number(x.saldocapital)
    };
}

